module.exports = __webpack_public_path__ + "static/media/globe-white.ed7e101f.svg";